module.exports = __webpack_public_path__ + "static/media/nordic-gym-group-lesson.df5df425.jpg";